import { render, staticRenderFns } from "./renLiuFenXi.vue?vue&type=template&id=5dec88a1&scoped=true"
import script from "./renLiuFenXi.vue?vue&type=script&lang=js"
export * from "./renLiuFenXi.vue?vue&type=script&lang=js"
import style0 from "./renLiuFenXi.vue?vue&type=style&index=0&id=5dec88a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dec88a1",
  null
  
)

export default component.exports